import React from 'react';
import { Helmet } from 'react-helmet-async';
import { RefreshCw, MessageCircle } from 'lucide-react';
import PolicyLayout from './PolicyLayout';
import { getWhatsAppLink } from '../lib/utils';

function ReturnPolicy() {
  return (
    <>
      <Helmet>
        <title>Return Policy - OldCoinage.com</title>
        <meta name="description" content="Learn about OldCoinage.com's return and refund policies." />
      </Helmet>

      <PolicyLayout title="Return Policy" lastUpdated="March 15, 2024">
        <div className="bg-green-50 border border-green-100 rounded-lg p-6 mb-8">
          <div className="flex items-start gap-4">
            <RefreshCw className="h-6 w-6 text-green-600 mt-1" />
            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">Customer Satisfaction Guaranteed</h2>
              <p className="text-gray-600">
                We stand behind the authenticity and quality of every item we sell.
              </p>
            </div>
          </div>
        </div>

        <h2>Return Eligibility</h2>
        <p>
          We accept returns within 7 days of delivery if:
        </p>
        <ul>
          <li>The item received differs from what was described</li>
          <li>The item's authenticity is questionable</li>
          <li>The item arrives damaged</li>
          <li>You receive the wrong item</li>
        </ul>

        <h2>Return Process</h2>
        <p>
          To initiate a return:
        </p>
        <ol>
          <li>Contact our customer service within 7 days of delivery</li>
          <li>Provide order details and reason for return</li>
          <li>Receive return shipping instructions</li>
          <li>Package the item securely with all original documentation</li>
          <li>Ship the item back using tracked shipping</li>
        </ol>

        <h2>Refund Process</h2>
        <p>
          Once we receive and inspect the returned item:
        </p>
        <ul>
          <li>Refund will be processed within 3-5 business days</li>
          <li>Original payment method will be refunded</li>
          <li>Shipping costs may be refunded for eligible returns</li>
        </ul>

        <h2>Non-Returnable Items</h2>
        <p>
          The following items cannot be returned:
        </p>
        <ul>
          <li>Items with removed or damaged authentication seals</li>
          <li>Items without original packaging and documentation</li>
          <li>Items showing signs of handling or tampering</li>
        </ul>

        <div className="bg-primary-50 border border-primary-100 rounded-lg p-6 mt-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Need Help with a Return?</h2>
          <p className="text-gray-600 mb-4">
            Our customer service team is available to assist you with returns:
          </p>
          <a
            href={getWhatsAppLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 text-white rounded-full hover:bg-primary-700 transition-colors font-medium"
          >
            <MessageCircle className="h-5 w-5" />
            Chat on WhatsApp
          </a>
          <p className="text-sm text-gray-500 mt-4">
            Business Hours: Monday to Saturday, 9 AM to 6 PM IST
          </p>
        </div>
      </PolicyLayout>
    </>
  );
}

export default ReturnPolicy;